import { forwardRef } from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

const PhoneNumberFormat = forwardRef<any, NumberFormatProps>(function PhoneNumberFormat(props, ref) {
  const { onChange, name, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange?.({
          target: {
            name: name,
            value: values.value,
          },
        } as any);
      }}
      name={name}
      format="### #### ####"
    />
  );
});

export default PhoneNumberFormat;
